import axiosInstance from "@js-app/services/http/axios-instance";
class CallbackOperationsApi {
    async getCallbackInformation(operationId) {
        return (
            await axiosInstance.get(`companies/callback/${operationId}`)
        ).data
    }
}

export default new CallbackOperationsApi();